export class HhsgSharedAppSettings {
    production: boolean;
    applicationName: string;
    portalHome: string;
    portalUrl: string;
    webApiServer: string;
    stsServer: string;
    redirect_url: string;
    client_id: string;
    response_type: string;
    scope: string;
    post_login_route: string;
    post_logout_redirect_uri: string;
    start_checksession: boolean;
    silent_renew: boolean;
    silent_renew_url: string;
    silent_renew_offset_in_seconds: number;
    forbidden_route: string;
    unauthorized_route: string;
    log_console_warning_active: boolean;
    log_console_debug_active: boolean;
    max_id_token_iat_offset_allowed_in_seconds: string;
    auto_clean_state_after_authentication: boolean;
    trigger_authorization_result_event: boolean;
    auto_userinfo: boolean;
    session_warning_time: number;
    tableau_server_url: string;
    tableau_ticket_server_url: string;
    tableau_token_server_url: string;
    ignoreNonceAfterRefresh: boolean;
    use_refresh_token: boolean;
    sgPortalApiServer: string;
    applicationAbbreviation: string;
    idleSessionTimeOut: number;
    quicksightApiUrl: string;
    editableEmailApps: string;
  }
